import React from 'react'

const OurMission = () => {
  return (
  <div className="pcb-container">
      <div className="pcb-text">
        <h2>Our Mission:
</h2>
        <p style={{ fontSize: '19px', lineHeight: '1.6' ,color:"black"}}>
     At Automotive Devices, we are committed to delivering high-quality and reliable PCBA manufacturing services, driven by precision, innovation, and a deep focus on customer satisfaction. Our goal is to support clients at every stage of their journey—from initial prototyping to full-scale production—through flexible and tailored solutions that meet their specific needs.

Built on strong family values and backed by industry expertise, we aim to be more than just a service provider—we strive to be a trusted partner. With attention to detail, operational efficiency, and a passion for excellence, we help bring our customers’ ideas to life, one project at a time.
       
        </p>
      </div>
      <div className="pcb-image">
        <img src='/images (1).jpeg' alt="PCB Assembly" />
      </div>
    </div>
  )
}

export default OurMission
